import { gql } from '../../../../../../../hooks/useQuery'

export const GET_MASSIVE_LABEL_INFO = gql`
  query GetMassiveLabelInfo($ids: String, $id_massive: ID) {
    t2MassiveLabelInfo(ids: $ids, id_massive: $id_massive) {
    }
  }
`
